import styled from "styled-components";

export const Wrapper = styled.div`
    // border:1px solid red;
`